module.exports = __webpack_public_path__ + "components/country-flag/static/kg-3cf4e9ddd862f368e8cc7ee9c588c9bd.svg";